import script from "./MonitoraggioOrizzontaleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitoraggioOrizzontaleForm.vue?vue&type=script&setup=true&lang=js"

import "./MonitoraggioOrizzontaleForm.vue?vue&type=style&index=0&id=4e17cb34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e17cb34"]])

export default __exports__